import React, { useContext, useEffect } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { TextBody, AboutDfsContainer } from './style';
import AboutDFSContext from '../../contexts/AboutDFSContext';
import Title from '../../components/Title';
import ErrorPage from '../ErrorPage';
import { createSafeHtml } from '../../utils/sanitizeHtml';

const AboutDFS = () => {
  const { imageUrl, title, description, error } = useContext(AboutDFSContext);

  useEffect(() => {
    document.title = "DFS | About DFS";
  });

  const imageStyle = {
    height: '220px',
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPositionX: '40%',
  };
  return error ? (
    <ErrorPage />
  ) : (
    <>
      <AboutDfsContainer>
        <div style={imageStyle} className="w-100" />
      </AboutDfsContainer>
      <Container>
        <Row className="mx-1 mx-sm-0 mb-5 pb-5">
          <Col tabIndex="0" xs="12" className="skip-nav-focus px-lg-0 mx-lg-0 mt-1">
            <Title className="my-3">{title}</Title>
            <TextBody>
              <div dangerouslySetInnerHTML={createSafeHtml(description)} />
            </TextBody>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AboutDFS;